import Component from '../abstracts/Component';

export default class EditorialCoverInfiniteComponent extends Component {

  get COMPONENTNAME() {
    return 'EditorialCoverInfiniteComponent';
  }

  get SELECTORS() {
    return {
      carousel: '#carousel'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
  }

  importSlick(carousel) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousel(carousel);
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousel(carousel) {
    const options = {
      arrows: false,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 0,
      slidesToShow: 3,
      infinite: true,
      speed: 3000,
      cssEase: 'linear',
    };
    $(carousel).slick(options);
  }

  render() {
    super.render();
    this.importSlick(this.carousel);
  }
}
